
/**
 * Get latLng object from leaflet event
 */
export const eventToLatlng = (e: any): { lat: number; lng: number; } => {
    const latlng = e.latlng || e.target._latlng;
    return { lat: latlng.lat, lng: latlng.lng }
}


export const latlngToCoords = (latlng: { lat: number; lng: number; }): [number, number] => {
    return [latlng.lat, latlng.lng]
}


export const roundCoords = (coords: [number, number], percision: number): [number, number] => {
    const x = Number(coords[0].toPrecision(percision));
    const y = Number(coords[1].toFixed(percision));
    return [x, y]
}